module.exports = __webpack_public_path__ + "img/hotstyleshow8.9a753420.jpg";